// @flow
import React, { type Node } from 'react';
import './QuotingTemplate.scss';

type Props = {
  children: Node,
};

const QuotingTemplate = ({ children }: Props) => <div className="QuotingTemplate">{children}</div>;

export default QuotingTemplate;



// WEBPACK FOOTER //
// ./src/components/quoting/QuotingTemplate/QuotingTemplate.js